import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CalendarCoinIcon = (props: SvgIconProps) => {
    const fill = props.fill ?? 'none';

    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill={fill} sx={{ ...props.sx, fill }}>
            <path d="M15 3V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 3V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 9H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M19 10V7C19 5.343 17.657 4 16 4H6C4.343 4 3 5.343 3 7V16C3 17.657 4.343 19 6 19H10"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 13C19.9853 13 22 15.0147 22 17.5C22 19.9853 19.9853 22 17.5 22C15.0147 22 13 19.9853 13 17.5C13 15.0147 15.0147 13 17.5 13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 15.7862V15.2147"
                stroke="currentColor"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 19.2147V19.7862"
                stroke="currentColor"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5095 18.8077C16.6564 19.0583 16.9242 19.2133 17.2147 19.2157H17.8433C18.2548 19.226 18.607 18.9222 18.6573 18.5135C18.7075 18.1049 18.4394 17.7249 18.0375 17.6352L16.9667 17.366C16.5696 17.273 16.306 16.896 16.355 16.4911C16.4039 16.0862 16.7497 15.7829 17.1575 15.7872H17.7861C18.0769 15.7891 18.345 15.9442 18.4918 16.1952"
                stroke="currentColor"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default CalendarCoinIcon;
